"use client"

import { memo } from "react"
import CategoryUnderline from "./CategoryUnderline"

const SectionBlock = ({
	label,
	name = "Maharashtra",
	url,
	viewAll = true,
	children,
	divider = false,
	className = "",
}) => (
	<section className={`${divider ? "pt-2 border-t border-(--border-default)" : ""} ${className}`}>
		{label && (
			<CategoryUnderline name={name} label={label} url={url} viewAll={viewAll} />
		)}
		{children}
	</section>
)

export default memo(SectionBlock)
